import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileQuestion, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set document title to indicate 404 status
    document.title = '404 - Page Not Found';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-nova-color">
      <div className="text-center px-4 py-8 max-w-md">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-gray-100 p-4">
            <FileQuestion className="w-12 h-12 text-gray-600" />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold mb-2 font-family-messina-modern">
          404
        </h1>
        
        <h2 className="text-2xl font-semibold mb-4 font-family-messina-modern text-gray-800">
          Page Not Found
        </h2>
        
        <p className="text-gray-600 mb-6 font-family-messina-sans">
          The page you're looking for doesn't exist or has been moved. Please check the URL and try again.
        </p>
        
        <div className="flex justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-2.5 bg-gray-200 text-gray-800 rounded-[4px] hover:bg-gray-300 transition-colors font-medium font-family-messina-sans"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

